import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ServiceAddContainer from "./ServiceAddContainer";
import styled from "styled-components";
import ServiceForms_1 from "./ServiceForms/ServiceForms_1";
import ServiceForms_2 from "./ServiceForms/ServiceForms_2";
import ServiceForms_3 from "./ServiceForms/ServiceForms_3";
import Axios from "axios";
import { postService } from "../../../redux/Actions/Service/serviceAction";
import {
  antdMessageError,
  antdMessageSuccess,
  emailValid,
  phonenumberValid,
} from "../../../helpers/Utils";
import { message } from "antd";

function ServiceScreenAdd({ onClose }) {
  const dispatch = useDispatch();
  const [level, setLevel] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searching, setSearching] = useState(false);

  const [information, setInformation] = useState({
    client: {
      client_name: "",
      client_lastname: "",
      client_phone: "",
      client_mail: "",
      client_country_id: "",
      client_city: "",
      client_street: "",
      client_postal_code: "",
    },
    form: {
      type: "",
      goods: [],
    },
    description: {
      breaks: "",
      goods_outside: "",
      complete_set: "",
      refuses_to_repair: "",
    },
  });

  const [errorsState, setErrors] = useState({});

  const [attachments, setAttachments] = useState({
    defect_act: {
      boolean: false,
      docs: [],
    },
    goods_appearance: {
      boolean: false,
      docs: [],
    },
    complaint: {
      boolean: false,
      docs: [],
    },
    refuses_to_repair: {
      boolean: false,
      docs: [],
    },
  });

  const onChangeHandler = (e, position, item) => {
    const { name, value } = e.target;
    if (item) {
      setInformation((prev) => ({
        ...prev,
        [position]: {
          ...information[position],
          item_name: item.title,
          item_price: item.price,
          item_code: item.item_code || "",
          serial_number: item.serial_number || "",
        },
      }));
      // return
      setErrors({
        ...errorsState,
        item_name: item.title ? false : true,
        item_price: item.price || item.price == 0 ? false : true,
      });
    } else {
      setInformation((prev) => ({
        ...prev,
        [position]: {
          ...information[position],
          [name]: value,
        },
      }));
      // return
      setErrors({
        ...errorsState,
        [name]: value ? false : true,
      });
    }
  };

  const onChangeAttachments = (name, nameAction, value) => {
    setAttachments({
      ...attachments,
      [name]: {
        ...attachments[name],
        [nameAction]: value,
      },
    });
  };

  const onChangeType = (e) => {
    const { name, value } = e.target;

    setInformation({
      ...information,
      form: {
        [name]: value,
        goods: [],
      },
    });
    // return
    setErrors({});
    setSearched(false);
  };

  const onSelectType = () => {
    const value = information.form.type;
    let strings = {};
    if (["Warranty","Non-warranty", "Defect act"].includes(value)) {
      const document_type_selected =
        information.form.document_type == "invoice"
          ? "sf"
          : information.form.document_type == "cheque"
          ? "pos"
          : information.form.document_type == "order"
          ? "order"
          : false;

      strings = {
        document_type: document_type_selected,
        document_identifier:
          document_type_selected == "order"
            ? information.form.order_id
            : information.form.buy_document,
      };
    } else if (value == "PPG") {
      strings = {
        document_type: "rpg",
        document_identifier: information.form.certificate_number,
      };
    } else if (value == "Pre-trade") {
      strings = {
        document_type: "pre-trade",
        document_identifier: information.form.item_code,
      };
    }

    setSearching(true);
    //
    Axios.get(
      `/api/v1/repair_services/get_products/${strings.document_type}/${strings.document_identifier}`
    )
      .then((res) => {
        if (res.data) {
          const { client_info, products, order_id } = res.data;

          if (products.length > 0) {
            const client_info_atr = client_info ? client_info : {};
            const rebuildPhoneNumber = (number) => {
              if (!number) return "";
              if (number) {
                let number_string = number + "";
                if (number_string.startsWith("370")) {
                  return number_string.split("370").join("");
                } else if (number_string.startsWith("+370")) {
                  return number_string.split("+370").join("");
                } else if (
                  number_string.length == 9 &&
                  number_string.startsWith("8")
                ) {
                  return number_string.split("8").join("");
                }
                return number;
              }
              return "";
            };
            setInformation((prev) => ({
              ...prev,
              form: {
                ...prev.form,
                goods: products,
                order_id: order_id || null,
              },
              client: {
                client_name: client_info_atr.firstname || "",
                client_lastname: client_info_atr.lastname || "",
                client_phone: typeof client_info_atr.phone
                  ? rebuildPhoneNumber(client_info_atr.phone)
                  : "",
                client_mail: client_info_atr.other || "",
                client_country_id: client_info_atr.country_id || undefined,
                client_city: client_info_atr.city || "",
                client_street: client_info_atr.street || "",
                client_postal_code: client_info_atr.postal_code
                  ? client_info_atr.postal_code + ""
                  : "",
              },
            }));
            antdMessageSuccess();
          } else {
            setInformation({
              ...information,
              client: {
                client_name: "",
                client_lastname: "",
                client_phone: "",
                client_mail: "",
                client_country_id: "",
                client_city: "",
                client_street: "",
                client_postal_code: "",
              },
              form: {
                ...information.form,
                goods: [],
                item_name: "",
                item_code: "",
                order_id: null,
              },
            });
            antdMessageError("Nerasta...");
          }
          setSearched(true);
        }
        setSearching(false);
      })
      .catch(() => {
        antdMessageError();
        setSearching(false);
      });
  };

  const onSave = () => {
    let errors = {};

    if (level === 1) {
      if (!information.form.type) {
        errors.type = "Select a type.";
      } else {
        const value = information.form.type;
  
        if (
          [null, false, undefined, 0, ""].includes(information.form.item_name)
        ) {
          errors.item_name = "Required";
        }
        if (
          ["Defect act", "Warranty", "Non-warranty"].includes(value) &&
          [null, false, undefined, 0, ""].includes(
            information.form.document_type
          )
        ) {
          errors.document_type = "Required";
        }
        if (
          information.form.document_type !== "order" &&
          ["Defect act", "Warranty", "Non-warranty"].includes(value) &&
          [null, false, undefined, 0, ""].includes(
            information.form.buy_document
          )
        ) {
          errors.buy_document = "Required";
        }

        if (
          ["PPG"].includes(value) &&
          [null, false, undefined, 0, ""].includes(
            information.form.certificate_number
          )
        ) {
          errors.certificate_number = "Required";
          errors.certificate_date = "Required";
        }

        if (
          ["Pre-trade"].includes(value) &&
          [null, false, undefined, 0, ""].includes(information.form.item_code)
        ) {
          errors.item_code = "Required";
        }
      }
      if (!information.form.item_name) {
        message.error("Select a product or start a search");
      }
    } else if (level === 2) {
      Object.entries(information.client).forEach((e) => {
        if (e[0] === "client_country_id") {
          if (!e[1]) {
            errors[e[0]] = "Required";
          }
        } else if (
          e[0] === "client_phone" &&
          !phonenumberValid("+370" + e[1])
        ) {
          errors[e[0]] = "Check the phone number";
        } else if (e[0] === "client_mail" && !emailValid(e[1])) {
          errors[e[0]] = "Check your email";
        } else if (e[1].trim() == "") {
          errors[e[0]] = "Required";
        }
      });
    } else if (level === 3) {
      if (information.description.breaks.trim() === "") {
        errors.breaks = "Required";
      }
    }

    if (Object.keys(errors).length > 0) {
      return setErrors(errors);
    }
    setLevel(level + 1);
    setErrors({});
    if (level === 3) {
      setLoading(true);
      dispatch(postService(information, attachments)).then((res) => {
        if (res.success) {
          setLoading(false);
          onClose(false);
        } else {
          setLoading(false);
          setLevel(1);
        }
      });
    }
  };

  return (
    <>
      <div className="col-12">
        <h6 className="font-weight-bold" style={{ fontSize: "21px" }}>
          New fault document
          {information.form.type && `: ${information.form.type}`}
          {information.form.order_id && ", pinned order."}
        </h6>
      </div>
      <ServiceAddContainer level={level}>
        {level == 1 ? (
          <ServiceForms_1
            form={information.form}
            onChangeType={onChangeType}
            onChangeHandler={onChangeHandler}
            onSelectType={onSelectType}
            errors={errorsState}
            searching={searching}
          />
        ) : level == 2 ? (
          <ServiceForms_2
            client={information.client}
            onChangeHandler={onChangeHandler}
            errors={errorsState}
          />
        ) : (
          <ServiceForms_3
            description={information.description}
            attachments={attachments}
            onChangeHandler={onChangeHandler}
            onChangeAttachments={onChangeAttachments}
            loading={loading}
            errors={errorsState}
          />
        )}
        {information.form.goods.length == 0 && searched && (
          <div className="pt-4">
            <h5 className="font-weight-bold">No products found</h5>
          </div>
        )}
        <div className="position-relative mt-4">
          <CustomButton
            className="btn btn-sm btn-outline-danger"
            style={{ visibility: level == 1 ? "visible" : "hidden" }}
            onClick={() => onClose(false)}
          >
            Cancel
          </CustomButton>
          <div
            className="position-absolute"
            style={{
              top: 0,
              left: "50%",
              transform: "translate(-50%, -0%)",
            }}
          >
            <CustomButton
              className="btn btn-sm btn-primary mr-1"
              style={{ visibility: level > 1 ? "visible" : "hidden" }}
              onClick={() => setLevel(level - 1)}
            >
              Back
            </CustomButton>
            <CustomButton
              className="btn btn-sm btn-danger ml-1"
              onClick={() => onSave()}
            >
              {level !== 3 ? "Next" : "Finish"}
            </CustomButton>
          </div>
        </div>
      </ServiceAddContainer>
    </>
  );
}

const CustomButton = styled.button`
  padding: 0.25rem 0.95rem;
  border-radius: 0.1rem;
  font-size: 13px;
`;
export default ServiceScreenAdd;
